import React from 'react';
import PropTypes from 'prop-types';
import { ConfigurationManager } from 'modules/shell/utils/config';
import { FeatureToggleContextProvider } from 'modules/shell/utils/toggles';
import { BRAND_PROFILES_LIST } from 'constants/index';

/**
 *
 * @param children
 * @returns {*}
 * @constructor
 */
export const FeatureTogglesProvider = ({ children }) => {
  const toggles = JSON.parse(window.localStorage.getItem('toggles'));

  return <FeatureToggleContextProvider value={toggles}>{children}</FeatureToggleContextProvider>;
};

FeatureTogglesProvider.propTypes = {
  config: PropTypes.instanceOf(ConfigurationManager).isRequired,
  logger: PropTypes.shape({}).isRequired,
  userId: PropTypes.string.isRequired,
  userADGroup: PropTypes.string,
  brand: PropTypes.oneOf(BRAND_PROFILES_LIST),
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
};

FeatureTogglesProvider.defaultProps = {
  brand: BRAND_PROFILES_LIST[0],
};

export default FeatureTogglesProvider;
